import { NotificationListModel } from "./NotificationList.model";

export class NotificationList extends NotificationListModel {
    // Add custom methods here
}
